/* eslint-disable react/prop-types */ // TODO: upgrade to latest eslint tooling
import * as React from 'react';
import { MIGRATION_PROMPT_SHOWN } from '../../constants';
import { ButtonPill } from '../button-pill';
import { StorageModel } from '../../modules/storage/model';
import { style } from 'typestyle';
import { px } from 'csx';
import { Component, deps, inject, observer } from '../../lib/component';

@inject(deps)
@observer
export default class MigrationRetriggerButton extends Component<React.Component['props']> {
  render() {
    const {
      children,
      model: { auth },
    } = this.props;

    if (auth.user.is_migrated !== true) return null;

    return (
      <div className={style({ display: 'flex', justifyContent: 'flex-end', marginBottom: px(16) })}>
        <ButtonPill tertiary={true} onClick={() => StorageModel.delete(MIGRATION_PROMPT_SHOWN)}>
          {children}
        </ButtonPill>
      </div>
    );
  }
}
